import { DOCUMENT_TAGS, type DocumentTag } from '@brickup/shared/constants'
import {
  FILTER_ALL,
  oneOf,
  selectedRowFilter,
  stringFilter,
  type AllOr,
} from '@/components/Internal/DataTable'

export type TagFilterValue = AllOr<DocumentTag>

export const documentListFilters = {
  tag: oneOf<TagFilterValue>(DOCUMENT_TAGS, FILTER_ALL),
  search: stringFilter(),

  selected: selectedRowFilter(),
}

/** Narrowing to `tag`, or back to everything where it is already the one. */
export const toggledTag = (
  value: TagFilterValue,
  tag: DocumentTag,
): TagFilterValue => (value === tag ? FILTER_ALL : tag)
